import React from "react";
import TopBar from "./top-bar";

const Header = () => <TopBar />;

Header.propTypes = {};

export default Header;
